import { useEffect, useRef } from 'react';

export const useLeaveFor = (history, listener) => {
  const listenerRef = useRef();

  useEffect(() => {
    listenerRef.current = listener;
  }, [listener]);

  useEffect(() => {
    // History is changing AFTER component unmounting
    const unlisten = history.listen((location) => {
      listenerRef.current(location);
      unlisten();
    });
  }, [history]);
};

export default useLeaveFor;
